import { http } from '../rest';

export function cancelAdvisorAttestation(http, demo) {
  return {
    async execute() {
      try {
        if (demo) {
          return true;
        }
        await http.post('/handle_advisor_cancelled_attestation');
      } catch (error) {
        if (error && error.response && error.response.status === 404) return;
        throw error;
      }
    },
  };
}

export default cancelAdvisorAttestation(http, process.env.DEMO);
